import React, { useState } from "react";
import ResizeListener from "../../../../utility/ResizeListener";
import { BlackClear } from "../../../resources/assetsManager";
import {
  BG_COLOR,
  LIGHT_GREY_BG_MODAL,
  WHITE_COLOR,
} from "../../../resources/colorsManager";
import AddCustomerBulk from "./bulk/AddCustomerBulk";
import AddCustomerIndividual from "./individual/AddCustomerIndividual";
import AddCustomerTabs from "./AddCustomerTabs";

function AddCustomerModalIndex({ onClose }) {
  const { width, height } = ResizeListener();
  const [step, setStep] = useState(0);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
        padding: "20px 30px",
        backgroundColor: WHITE_COLOR,
        minWidth: 400,
        borderRadius: 30,
        width: "100%",
        minHeight: height * 0.55,
        height: "100%",
        // alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p
          style={{
            fontSize: 18,
            fontWeight: "600",
            width: "100%",
            textAlign: "center",
          }}
        >
          Add Customer
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: BG_COLOR,
            padding: 10,
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          <img src={BlackClear} />
        </div>
      </div>

      <div
        style={{
          marginBottom: 50,
        }}
      >
        {step === 0 ? (
          <AddCustomerIndividual onClose={onClose} />
        ) : step === 1 ? (
          <AddCustomerBulk height={height} width={width} />
        ) : null}
      </div>
    </div>
  );
}

export default AddCustomerModalIndex;
